import AuthService from "../../api/services/auth";
import UserService from "../../api/services/user";

export default {
  namespaced: true,
  state: {
    currentUser: {},
    signedIn: false,
    csrf: null,
  },

  getters: {
    isEstalyManager: () => true, // TODO : to change (state) => state.currentUser.profileType === "EstalyManager",
  },

  mutations: {
    setCurrentUser(state, { currentUser, csrf }) {
      state.currentUser = currentUser;
      state.signedIn = true;
      state.csrf = csrf;
    },

    unsetCurrentUser(state) {
      state.currentUser = {};
      state.signedIn = false;
      state.csrf = null;
    },

    refresh(state, csrf) {
      state.csrf = csrf;
      state.signedIn = true;
    },
  },

  actions: {
    async signin({ dispatch }, user) {
      const response = await AuthService.signin(user);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async googleSignin({ dispatch }, credential) {
      const response = await AuthService.googleSignin(credential);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async signup({ dispatch }, params) {
      const response = await AuthService.signup(params);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async resetPassword({ dispatch }, { resetPasswordToken, payload }) {
      const response = await AuthService.resetPassword(resetPasswordToken, payload);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async postSignIn(context, response) {
      const csrf = response.data.csrf;
      if (csrf) {
        const resp = await UserService.getUser();
        const currentUser = resp.data;
        context.commit("setCurrentUser", { currentUser, csrf });
        context.dispatch("cable/connect", null, { root: true });
        context.dispatch("notifications/clearAll", null, { root: true });
      } else {
        context.commit("unsetCurrentUser");
      }
    },

    async forgotPassword(_, email) {
      return await UserService.forgotPassword(email);
    },

    async signout({ commit, dispatch }) {
      const response = await AuthService.signout();
      if (!response?.success) return response;

      dispatch("cable/disconnect", null, { root: true });
      commit("unsetCurrentUser");
      // Clear vuex states
      localStorage.removeItem("vuex_bo");
      sessionStorage.clear();
      location.replace("/signin");
    },
  },
};
